import { Route, Routes } from "react-router-dom";
import { PageProvider } from "../PageContext";

export interface RouteContainerProps {
  element?: React.ReactNode | null;
  children?: React.ReactNode;
}

const RouteContainer = ({ element, children }: RouteContainerProps) => {
  return (
    <PageProvider>
      <Routes>
        <Route path="/" element={element}>
          {children}
        </Route>
      </Routes>
    </PageProvider>
  );
};

export default RouteContainer;
